import React, { useEffect, useState } from 'react';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { SelectButton } from 'primereact/selectbutton';
import { Divider } from 'primereact/divider';
import { Fieldset } from 'primereact/fieldset';
import { TravelStatus } from '../../common/util/constants';
import { travelService } from '../../services/extensions';
import { toast } from 'react-toastify';
import { confirmDialog } from "primereact/confirmdialog";
import { capitalize } from '../../services/utility/helper';
import { Dialog } from 'primereact/dialog';
import { Card } from 'react-bootstrap';
import { Panel } from 'primereact/panel';
import { Timeline } from 'primereact/timeline';
import moment from 'moment';
import RejectTravelDialog from './RejectTravelDialog';


const TeamRequestApproval = () => {
    const [selectedLeave, setSelectedLeave] = useState([]);
    // const options = ["Current Week", "Last 3 Week", "Custom"];
    const [leaveInReview, setLeaveInReview] = useState([]);
    const [visible, setVisible] = useState(false);
    const [selectedTravelRecord, setSelectedTravelRecord] = useState(null);
    const [rejectDialog, setRejectDialog] = useState(false); // State to manage reject dialog visibility
    const [rejectRowData, setRejectRowData] = useState(null);
    useEffect(() => {
        fetchInReviewTravels();
    }, []);

    const fetchInReviewTravels = async () => {
        try {
            const resp = await travelService.GetUserReviewtravelBySuperior();
            const filteredData = resp.data.data.filter(item =>
                item.Travels.some(travel => travel.status === TravelStatus.SUBMITTED_TO_APPROVER)
            );
            setLeaveInReview(filteredData);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const requestedDateTemplate = (rowData) => {
        if (rowData.Travels && rowData.Travels.length > 0) {
            return moment(rowData.Travels[0].createdAt).format('DD/MM/YYYY');
        }
        return 'N/A';
    };

    const journeyDateTemplate = (rowData) => {
        if (rowData.Travels && rowData.Travels.length > 0) {
            return rowData.Travels[0].journeyDate ? moment(rowData.Travels[0].journeyDate).format('DD/MM/YYYY') : 'N/A';
        }
        return 'N/A';
    };

    const lastApprovedDateTemplate = (rowData) => {
        if (rowData.Travels && rowData.Travels.length > 0) {
            return moment(rowData.Travels[0].updatedAt).format('DD/MM/YYYY');
        }
        return 'N/A';
    };

    const userNameTemplate = (rowData) => {
        return `${rowData.firstName} ${rowData.lastName}`;
    };

    const Designationtitle = (rowData) => {
        return <div>
            <p>{rowData.Designation?.title || 'N/A'}</p>
        </div>
    };

    const BusinessUnittitle = (rowData) => {
        return <div>
            <p>{rowData.BusinessUnit?.title || 'N/A'}</p>
        </div>
    };

    const projectBodyTemplate = (rowData) => {
        return (
            <>
                {rowData.Allocations?.map(allocation => (
                    <div key={allocation.id}>
                        {allocation.Project?.title || 'N/A'} ({allocation.percentage}%)
                    </div>
                ))}
            </>
        );
    };

    const approvesingleRecord = async (rowData) => {
        confirmDialog({
            // target: e.currentTarget,
            message: 'Are you sure you want to approve this record?',
            header: 'Request Confirmation',
            icon: 'pi pi-info-circle',
            acceptClassName: "p-button-danger",
            acceptLabel: 'No',
            rejectLabel: 'Yes',
            reject: () => {
                let param = {
                    travels: rowData.Travels.map((e) => e.id),
                    status: TravelStatus.APPROVED_BY_MANAGER
                };
                try {
                    travelService.ApproveRejecttravelBulk([param]);
                    setSelectedLeave([]);
                    fetchInReviewTravels();
                    toast.success(`${capitalize(rowData.firstName)} ${capitalize(rowData.lastName)}'s travel request has been approved.`);
                } catch (err) {
                    console.error('Approve Error:', err);
                    toast.error('Unable to approve travel request.');
                }
            },
            accept: () => { }
        });
    };

    const rejectsingleRecord = (rowData) => {
        setRejectRowData(rowData);
        setRejectDialog(true);
    };

    const handleReject = async (reason) => {
        let param = {
            travels: rejectRowData.Travels.map((e) => e.id),
            status: TravelStatus.REJECTED_BY_MANAGER,
            reason: reason
        };
        try {
            const resp = await travelService.ApproveRejecttravelBulk([param]);
            console.log('Reject Response:', resp);
            setSelectedLeave([]);
            fetchInReviewTravels();
            setRejectDialog(false);
            toast.success(`${capitalize(rejectRowData.firstName)} ${capitalize(rejectRowData.lastName)}'s travel request has been rejected.`);
        } catch (err) {
            console.error('Reject Error:', err);
            setRejectDialog(false);
            toast.error('Unable to reject travel request.');
        }
    };

    const actionBody = (rowData) => {
        return (
            <React.Fragment>
                <Button icon="pi pi-check" className="p-button-rounded p-button-primary mr-2" onClick={() => approvesingleRecord(rowData)} />
                <Button icon="pi pi-times" className="p-button-rounded p-button-danger mr-2" onClick={() => rejectsingleRecord(rowData)} />
                <Button icon="pi pi-eye" className="p-button-rounded p-button-secondary mr-2" onClick={() => handleViewDetail(rowData)} />
            </React.Fragment>
        );
    };

    const rightToolbarTemplate = () => {
        return (
            <React.Fragment>
                <SelectButton
                //    options={options}
                />
            </React.Fragment>
        );
    };

    const approveLeave = async (selectedLeave) => {
        let idList = [];
        selectedLeave?.map(x => x.Travels?.map(y => {
            idList.push(y.id);
        }));
        let param = {
            travels: idList,
            status: TravelStatus.APPROVED_BY_MANAGER
        };
        try {
            const resp = await travelService.ApproveRejecttravelBulk([param]);
            console.log('Bulk Approve Response:', resp);
            toast.success(capitalize(selectedLeave[0].firstName) + " " + capitalize(selectedLeave[0].lastName) + " travels have been approved");
            setSelectedLeave([]);
            fetchInReviewTravels();
        } catch (err) {
            console.error('Bulk Approve Error:', err);
            toast.error('Unable to approve selected travel requests.');
        }
    };

    const rejectLeave = async (selectedLeave) => {
        let idList = [];
        selectedLeave?.map(x => x.Travels?.map(y => {
            idList.push(y.id);
        }));
        let param = {
            travels: idList,
            status: TravelStatus.REJECTED_BY_MANAGER,
            reason: "rejected"
        };
        try {
            const resp = await travelService.ApproveRejecttravelBulk([param]);
            console.log('Bulk Reject Response:', resp);
            toast.error(capitalize(selectedLeave[0].firstName) + " " + capitalize(selectedLeave[0].lastName) + " travels have been rejected");
            setSelectedLeave([]);
            fetchInReviewTravels();
        } catch (err) {
            console.error('Bulk Reject Error:', err);
            toast.error('Unable to reject selected travel requests.');
        }
    };

    const handleViewDetail = (rowData) => {
        setSelectedTravelRecord(rowData);
        setVisible(true);
    };

    return (
        <>
            <div className="col-12">
                <div className="tabview-demo col-12">
                    <Fieldset>
                        <h1>Team Members - Awaiting Approvals</h1>
                        <Divider />
                        <div className="formgrid grid mt-4">
                            <div className="field col-2">
                                <Button label="Approve All"
                                    className="w-100"
                                    style={{ marginRight: "10px" }}
                                    onClick={() => approveLeave(selectedLeave)}
                                    disabled={selectedLeave.length === 0}
                                />
                            </div>
                            <div className="field col-2">
                                <Button label="Reject All"
                                    className="p-button-danger w-100"
                                    onClick={() => rejectLeave(selectedLeave)}
                                    disabled={selectedLeave.length === 0}
                                />
                            </div>
                            <div className="field col-8">
                                <div style={{ textAlign: "right" }}>
                                    {rightToolbarTemplate()}
                                </div>
                            </div>
                        </div>

                        <DataTable
                            className="mt-4 travels-data"
                            paginator
                            responsiveLayout="scroll"
                            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                            currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                            rows={10}
                            rowsPerPageOptions={[10, 20, 50]}
                            dataKey="id"
                            value={leaveInReview}
                            selection={selectedLeave}
                            onSelectionChange={(e) => setSelectedLeave(e.value)}
                            resizableColumns
                            columnResizeMode="fit"
                            scrollable="horizontal"
                            stripedRows
                            editMode="row"
                        >
                            <Column selectionMode="multiple" headerStyle={{ width: "10px" }}></Column>
                            <Column header="Requested Date" body={requestedDateTemplate} />
                            <Column header="ECN" field='ecn' />
                            <Column header="User Name" body={userNameTemplate} />
                            <Column header="Designation" body={Designationtitle} />
                            <Column header="BU" body={BusinessUnittitle} />
                            <Column header="Project" body={projectBodyTemplate} />
                            <Column header="Travel Date" body={journeyDateTemplate} />
                            <Column header="Action" body={actionBody} />
                        </DataTable>
                    </Fieldset>

                    <RejectTravelDialog
                        visible={rejectDialog}
                        onHide={() => setRejectDialog(false)}
                        onReject={handleReject}
                        travelRecord={rejectRowData}
                    />
                    <Dialog header="Travel Detail" className="pop-up-dialog add-timesheet custom_popup" visible={visible} style={{ width: '95vw' }} onHide={() => setVisible(false)}>
                        <div>
                            <div className="flex flex-column w-70">
                                {/* <Timeline value={progressStatus} layout="horizontal" align="bottom" content={(item) => item} opposite={<span>&nbsp;</span>} /> */}
                            </div>
                            {selectedTravelRecord && selectedTravelRecord.Travels && selectedTravelRecord.Travels.map((travel, index) => (
                                <Panel key={travel.id} className='traveldetail'>
                                    <div className='formgrid grid'>
                                        <div className='col-12'>
                                            <Card>
                                                <div className='d-flex-space-bet'>
                                                    <h1>Traveler Detail {index + 1}</h1>
                                                </div>
                                                <hr />
                                                <div className="formgrid grid">
                                                    <div className='field col-3 single-category'>
                                                        <h2>Trip Type</h2>
                                                        <p>{travel.tripTypeInfo?.title || 'N/A'}</p>
                                                    </div>
                                                    <div className='field col-3 single-category'>
                                                        <h2>Visa Type</h2>
                                                        <p>{travel.visaTypeInfo?.title || 'N/A'}</p>
                                                    </div>
                                                    <div className='field col-3 single-category'>
                                                        <h2>User ECN</h2>
                                                        <p>{travel.empEcn || 'N/A'}</p>
                                                    </div>
                                                    <div className='field col-3 single-category'>
                                                        <h2>Manager ECN</h2>
                                                        <p>{travel.managerEcn || 'N/A'}</p>
                                                    </div>
                                                </div>
                                                <div className="formgrid grid">
                                                    <div className='field col-3 single-category'>
                                                        <h2>Traveller Name</h2>
                                                        <p>{selectedTravelRecord.firstName} {selectedTravelRecord.lastName}</p>
                                                    </div>
                                                    {/* <div className='field col-2 single-category'>
                                                        <h2>Traveller Initiated By</h2>
                                                        <p>{travel.createdBy || 'N/A'}</p>
                                                    </div> */}
                                                    <div className='field col-3 single-category'>
                                                        <h2>Surname</h2>
                                                        <p>{selectedTravelRecord.lastName}</p>
                                                    </div>
                                                    <div className='field col-3 single-category'>
                                                        <h2>User Name</h2>
                                                        <p>{selectedTravelRecord.firstName}</p>
                                                    </div>
                                                    <div className='field col-3 single-category'>
                                                        <h2>Designation</h2>
                                                        <p>{selectedTravelRecord.Designation?.title || 'N/A'}</p>
                                                    </div>
                                                </div>
                                                <div className="formgrid grid">
                                                    <div className='field col-3 single-category'>
                                                        <h2>Mobile Number</h2>
                                                        <p>{selectedTravelRecord.phone || 'N/A'}</p>
                                                    </div>
                                                    <div className='field col-3 single-category'>
                                                        <h2>Email ID</h2>
                                                        <p>{selectedTravelRecord.email || 'N/A'}</p>
                                                    </div>
                                                    <div className='field col-3 single-category'>
                                                        <h2>Grade</h2>
                                                        <p>{travel.grade || 'N/A'}</p>
                                                    </div>
                                                    <div className='field col-3 single-category'>
                                                        <h2>Traveller Comments</h2>
                                                        <p>{travel.comment || 'N/A'}</p>
                                                    </div>
                                                </div>
                                            </Card>
                                        </div>
                                        <div className='col-12'>
                                            <Card>
                                                <div className='d-flex-space-bet'>
                                                    <h1>Traveller Detail</h1>
                                                </div>
                                                <hr />
                                                <div className="formgrid grid">
                                                    <div className='field col-3 single-category'>
                                                        <h2>Client Name</h2>
                                                        <p>{selectedTravelRecord?.Travels[0]?.customerInfo?.title || 'N/A'}</p>
                                                    </div>
                                                    <div className='field col-3 single-category'>
                                                        <h2>Project Name</h2>
                                                        <p>{selectedTravelRecord?.Allocations[0]?.Project?.title || 'N/A'}</p>
                                                    </div>
                                                    <div className='field col-3 single-category'>
                                                        <h2>Project Manager</h2>
                                                        <p>{selectedTravelRecord?.Allocations[0]?.Project?.pm?.firstName + " " + selectedTravelRecord?.Allocations[0]?.Project?.pm?.lastName || 'N/A'}</p>
                                                    </div>
                                                    <div className='field col-3 single-category'>
                                                        <h2>BU/Functional Head</h2>
                                                        <p>{selectedTravelRecord?.BusinessUnit?.title || 'N/A'}</p>
                                                    </div>
                                                </div>
                                                <div className="formgrid grid">
                                                    <div className='field col-3 single-category'>
                                                        <h2>Country of Visit</h2>
                                                        <p>{selectedTravelRecord?.Travels[0]?.countryInfo?.countryName || 'N/A'}</p>
                                                    </div>
                                                    <div className='field col-3 single-category'>
                                                        <h2>State/Cities</h2>
                                                        <p>{selectedTravelRecord?.Travels[0]?.stateInfo?.stateName || 'N/A'}</p>
                                                    </div>
                                                    <div className='field col-3 single-category'>
                                                        <h2>Journey Date</h2>
                                                        <p>{travel.journeyDate ? moment(travel.journeyDate).format('DD/MM/YYYY') : 'N/A'}</p>
                                                    </div>
                                                    <div className='field col-3 single-category'>
                                                        <h2>Return Date</h2>
                                                        <p>{travel.returnDate ? moment(travel.returnDate).format('DD/MM/YYYY') : 'N/A'}</p>
                                                    </div>
                                                </div><div className="formgrid grid">
                                                    <div className='field col-3 single-category'>
                                                        <h2>Cost Center</h2>
                                                        <p>{travel.costCenter || 'N/A'}</p>
                                                    </div>
                                                    <div className='field col-3 single-category'>
                                                        <h2>DA Currency</h2>
                                                        <p>{travel.daCurrency || 'N/A'}</p>
                                                    </div>
                                                    <div className='field col-3 single-category'>
                                                        <h2>DA Entitle Amount</h2>
                                                        <p>{travel.daentitleAmmount || 'N/A'}</p>
                                                    </div>
                                                    <div className='field col-3 single-category'>
                                                        <h2>Seat Request</h2>
                                                        <p>{travel.seatRequest || 'N/A'}</p>
                                                    </div>
                                                </div><div className="formgrid grid">
                                                    <div className='field col-3 single-category'>
                                                        <h2>Meal Request</h2>
                                                        <p>{travel.mealRequest || 'N/A'}</p>
                                                    </div>
                                                    <div className='field col-6 single-category'>
                                                        <h2>Frequently Flyer Number</h2>
                                                        <p>{travel.frequentflyerNumber || 'N/A'}</p>
                                                    </div>
                                                </div>
                                            </Card>
                                        </div>
                                        <div className='col-12'>
                                            <Card>
                                                <div className='d-flex-space-bet'>
                                                    <h1>Passport Detail</h1>
                                                </div>
                                                <hr />
                                                <div className="formgrid grid">
                                                    <div className='field col-3 single-category'>
                                                        <h2>Passport Number</h2>
                                                        <p>{travel.travelDetails?.[0]?.passportNumber || 'N/A'}</p>
                                                    </div>
                                                    <div className='field col-3 single-category'>
                                                        <h2>Date of Birth</h2>
                                                        <p>{travel.travelDetails?.[0]?.dateOfBirth ? moment(travel.travelDetails[0].dateOfBirth).format('DD/MM/YYYY') : 'N/A'}</p>
                                                    </div>
                                                    <div className='field col-3 single-category'>
                                                        <h2>Place of Issue</h2>
                                                        <p>{travel.travelDetails?.[0]?.placeOfIssue || 'N/A'}</p>
                                                    </div>
                                                    <div className='field col-3 single-category'>
                                                        <h2>Issue of Passport</h2>
                                                        <p>{travel.travelDetails?.[0]?.dateOfIssueOfPassport ? moment(travel.travelDetails[0].dateOfIssueOfPassport).format('DD/MM/YYYY') : 'N/A'}</p>
                                                    </div>
                                                </div>
                                                <div className="formgrid grid">
                                                    <div className='field col-3 single-category'>
                                                        <h2>Expire In Passport</h2>
                                                        <p>{travel.travelDetails?.[0]?.dateOfexpireOfPassport ? moment(travel.travelDetails[0].dateOfexpireOfPassport).format('DD/MM/YYYY') : 'N/A'}</p>
                                                    </div>
                                                    <div className='field col-6 single-category'>
                                                        <h2>Address as per the Passport</h2>
                                                        <p>{travel.travelDetails?.[0]?.addressAsPerthefPassport || 'N/A'}</p>
                                                    </div>
                                                </div>
                                            </Card>
                                        </div>
                                        <div className='col-12'>
                                            <Card>
                                                <div className='d-flex-space-bet'>
                                                    <h1>Insurance Detail</h1>
                                                </div>
                                                <div className="formgrid grid">
                                                    <div className='field col-4 single-category'>
                                                        <h2>Current Residence Address</h2>
                                                        <p>{travel.travelDetails?.[0]?.currentResidenceAddress || 'N/A'}</p>
                                                    </div>
                                                    <div className='field col-4 single-category'>
                                                        <h2>Nominee Name</h2>
                                                        <p>{travel.travelDetails?.[0]?.nomineeName || 'N/A'}</p>
                                                    </div>
                                                    <div className='field col-4 single-category'>
                                                        <h2>Relation With Nominee</h2>
                                                        <p>{travel.travelDetails?.[0]?.relationWithNominee || 'N/A'}</p>
                                                    </div>
                                                </div>
                                            </Card>
                                        </div>
                                    </div>
                                </Panel>
                            ))}
                        </div>
                    </Dialog>
                    {/* <RejectTravelDialog
                        visible={rejectDialog}
                        onHide={() => setRejectDialog(false)}
                        onReject={handleReject}
                        rowData={rejectRowData}
                    /> */}
                </div>
            </div>
        </>
    );
};

export default TeamRequestApproval;
